module.exports = __webpack_public_path__ + "static/media/5.a50460b6.jpg";